import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";
import RouteCityModel from "../../models/masters/routecity-model";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/RouteCity/GetAllRouteCity";// //{/api/RouteCity/GetAllRouteCity}`)  //// "https://localhost:7054/api/RouteCity/GetAllRouteCity";
export const useGetRouteCity = createQuery<
RouteCityModel[],
  null,
  AxiosError
>({
  queryKey: ["keyRouteCitylist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
